import React, { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { api } from "../../lib/api";

export default function EmployeeStatsPanel() {
  const today = new Date();
  const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  const [month, setMonth] = useState(defaultMonth);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/dashboard/employee-stats?month=${month}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ top_defects: [], top_parts: [] }));
  }, [month]);

  const fmtMonth = (ym) => {
    try {
      const [y, m] = ym.split("-");
      return new Date(parseInt(y), parseInt(m) - 1, 1).toLocaleDateString("ro-RO", { month: "long", year: "numeric" });
    } catch { return ym; }
  };

  return (
    <div className="card-flat p-5 mb-10 border-l-4 border-l-orange-500" data-testid="employee-stats-panel">
      <div className="flex items-center justify-between mb-4 gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md bg-orange-100 text-orange-600 grid place-items-center"><Wrench size={20}/></div>
          <div>
            <h3 className="font-display text-lg font-bold">Activitate angajați · {fmtMonth(month)}</h3>
            <div className="text-xs text-zinc-500">Defecte raportate și piese consumate</div>
          </div>
        </div>
        <input
          type="month"
          value={month}
          max={defaultMonth}
          onChange={(e) => setMonth(e.target.value)}
          className="border rounded px-2 py-1 text-sm"
          data-testid="emp-stats-month"
        />
      </div>
      {!data ? (
        <div className="text-sm text-zinc-400 py-4">Se încarcă…</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div data-testid="emp-stats-defects">
            <div className="text-[10px] uppercase tracking-wider text-zinc-500 font-bold mb-2">Top {data.top_defects?.length || 0} cu defecte raportate</div>
            {(!data.top_defects || data.top_defects.length === 0) ? (
              <div className="text-xs text-zinc-400 italic py-4 text-center bg-zinc-50 rounded">Nicio raportare luna asta. 🎉</div>
            ) : (
              <div className="space-y-1.5">
                {data.top_defects.map((row, i) => {
                  const max = data.top_defects[0].count || 1;
                  const pct = Math.round((row.count / max) * 100);
                  return (
                    <div key={i} className="flex items-center gap-3" data-testid={`emp-stats-defect-row-${i}`}>
                      <div className="w-6 text-right font-bold text-zinc-400 text-xs">{i + 1}</div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-baseline justify-between">
                          <span className="text-sm font-medium truncate">{row.user}</span>
                          <span className="text-xs font-bold text-orange-600 ml-2">{row.count}</span>
                        </div>
                        <div className="h-1.5 bg-zinc-100 rounded-full overflow-hidden mt-1">
                          <div className="h-full bg-orange-500 rounded-full" style={{ width: `${pct}%` }}/>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div data-testid="emp-stats-parts">
            <div className="text-[10px] uppercase tracking-wider text-zinc-500 font-bold mb-2">Top {data.top_parts?.length || 0} piese consumate</div>
            {(!data.top_parts || data.top_parts.length === 0) ? (
              <div className="text-xs text-zinc-400 italic py-4 text-center bg-zinc-50 rounded">Nicio reparație luna asta.</div>
            ) : (
              <div className="space-y-1.5">
                {data.top_parts.map((row, i) => {
                  const max = data.top_parts[0].uses || 1;
                  const pct = Math.round((row.uses / max) * 100);
                  return (
                    <div key={i} className="flex items-center gap-3" data-testid={`emp-stats-part-row-${i}`}>
                      <div className="w-6 text-right font-bold text-zinc-400 text-xs">{i + 1}</div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-baseline justify-between">
                          <span className="text-sm font-medium truncate">{row.name}</span>
                          <span className="text-xs font-bold text-sky-600 ml-2">×{row.uses}</span>
                        </div>
                        <div className="h-1.5 bg-zinc-100 rounded-full overflow-hidden mt-1">
                          <div className="h-full bg-sky-500 rounded-full" style={{ width: `${pct}%` }}/>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
